<template>
    <div class="register-card">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div class="register-body">
            <div class="reg-header">
                <span class="header-text">Reset Password</span>
            </div>
            <div class="reg-input-group">
                <div class="info-inputs">
                    <div class="input-wrapper">
                        <label class="name-label" for="email"
                            ><span class="label">Email *</span></label
                        >
                        <input type="hidden" name="token" v-model="token" />
                        <input
                            class="main-info-input"
                            required
                            type="email"
                            placeholder="Email"
                            @blur="$v.email.$touch"
                            v-model="$v.email.$model"
                            name="email"
                            id="email"
                        />
                        <span class="error-form-message" v-if="emailError">
                            Field is required
                        </span>
                        <span class="error-form-message" v-if="emailValidate">
                            {{ emailValidate }}
                        </span>
                        <span
                            class="error-form-message"
                            v-if="$v.email.$dirty && !$v.email.email"
                        >
                            Enter email
                        </span>
                    </div>
                    <div class="input-wrapper">
                        <label class="name-label" for="pass"
                            ><span class="label">Password *</span></label
                        >
                        <input
                            class="main-info-input"
                            :type="passwordVisible ? 'text' : 'password'"
                            name="password"
                            placeholder="Password"
                            id="pass"
                            @blur="$v.password.$touch"
                            v-model.trim="$v.password.$model"
                            autocomplete="new-password"
                        />
                        <i
                            class="fa"
                            :class="passwordVisible ? 'fa-eye' : 'fa-eye-slash'"
                            aria-hidden="true"
                            @click="togglePasswordVisibility"
                        ></i>
                        <span
                            class="error-form-message"
                            v-if="$v.password.$dirty && !$v.password.required"
                        >
                            Password is required.
                        </span>
                        <span
                            class="error-form-message"
                            v-if="$v.password.$dirty && !$v.password.minLength"
                        >
                            Password must have at least
                            {{ $v.password.$params.minLength.min }} letters.
                        </span>
                    </div>
                    <div class="input-wrapper">
                        <label class="name-label" for="pass-repeat"
                            ><span class="label">Confirm password *</span></label
                        >
                        <input
                            class="main-info-input"
                            :type="passwordVisible ? 'text' : 'password'"
                            name="password_confirmation"
                            placeholder="Confirm Password"
                            id="pass-repeat"
                            v-model.trim="$v.confirmPassword.$model"
                        />
                        <i
                            class="fa"
                            :class="passwordVisible ? 'fa-eye' : 'fa-eye-slash'"
                            aria-hidden="true"
                            @click="togglePasswordVisibility"
                        ></i>
                        <span
                            class="error-form-message"
                            v-if="!$v.confirmPassword.sameAsPassword"
                        >
                            Passwords must be identical.
                        </span>
                    </div>
                </div>
                <div class="call-to-action">
                    <button class="btn" @click="RegisterSuccess">
                        <span class="btn-text">Reset Password</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { required, minLength, email, sameAs, maxLength } from 'vuelidate/lib/validators'
    import { useAuth } from '@/composables/auth/useAuth'

    export default {
        name: 'PasswordReset',
        validations: {
            email: { required, email },
            password: { required, minLength: minLength(6), maxLength: maxLength(25) },
            confirmPassword: { required, sameAsPassword: sameAs('password') }
        },
        setup() {
            const { handleShowLoginModal } = useAuth()

            return {
                handleShowLoginModal
            }
        },
        data() {
            return {
                email: '',
                password: '',
                confirmPassword: '',
                passwordVisible: false,
                token: '',
                load: false
            }
        },

        created() {
            this.token = this.getToken()
        },
        methods: {
            async RegisterSuccess() {
                this.load = true
                try {
                    await axios.post('/password/reset', {
                        email: this.email,
                        password: this.password,
                        password_confirmation: this.confirmPassword,
                        token: this.token
                    })
                    this.load = false
                    this.handleShowLoginModal()
                } catch (error) {
                    this.load = false
                    if (error.response.data.errors.email)
                        this.emailValidate = error.response.data.errors.email[0]
                }
            },
            togglePasswordVisibility() {
                this.passwordVisible = !this.passwordVisible
            },
            getToken() {
                const url = window.location.href
                const tokenRegex = /\/password\/reset\/([^?]+)/
                const match = url.match(tokenRegex)
                if (match && match[1]) {
                    const token = match[1]
                    return token
                }
                return null
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .register-card {
        display: flex;
        flex-basis: 60%;
        align-items: center;
        justify-content: center;

        .register-body {
            font-family: Instrument Sans;
            display: flex;
            padding: 48px 80px;
            flex-direction: column;
            gap: 48px;
            border-radius: 15px;
            background: #262626;
            margin-top: 100px;
            margin-bottom: 15px;
            max-width: 60%;
            min-width: 60%;
            align-items: stretch;

            @media only screen and (max-width: 768px) {
                max-width: 100%;
                padding: 10%;
            }

            .header-text {
                color: #f5f5f5;
                font-size: 44px;
                font-style: normal;
                font-weight: 500;
                line-height: 110%;
                letter-spacing: -1.76px;

                @media only screen and (max-width: 768px) {
                    font-size: 1.5em;
                }
            }

            .reg-input-group {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 50px;

                .call-to-action {
                    display: flex;
                    min-width: 100%;

                    .btn {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        min-width: 100%;
                        padding: 11px 30px 12px 30px;
                        border-radius: 100px;
                        background: #cdeb09;
                        border: none;

                        .btn-text {
                            color: #000;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 550;
                            line-height: 120%;
                        }
                    }
                }

                .info-inputs {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 6px;
                    align-self: stretch;

                    .input-wrapper {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 6px;
                        align-self: stretch;
                        position: relative;

                        .label {
                            color: #8b8b8b;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 135%;
                            letter-spacing: 0.12px;
                        }

                        .main-info-input {
                            display: flex;
                            flex: 1;
                            padding: 12px 16px 16px 16px;
                            align-items: flex-start;
                            gap: var(--2, 8px);
                            align-self: stretch;
                            border-radius: 12px;
                            border: 1.5px solid #8b8b8b;
                            background: #262626;
                            color: #f5f5f5;

                            &::placeholder {
                                overflow: hidden;
                                color: #646464;
                                text-overflow: ellipsis;
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 550;
                                line-height: 125%;
                            }
                        }

                        .fa {
                            color: #acacac;
                            position: absolute;
                            top: 60%;
                            left: 95%;
                            @media only screen and (max-width: 768px) {
                                left: revert;
                                right: 0;
                            }
                        }
                    }
                }
            }
        }
    }

    .error-form-message {
        color: #ed3c0d;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
</style>
